import { getCookie, setCookie } from '../Utils/Utils'

export const trackCTAEventsObj = (obj) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': obj.event,
    'page_name': obj.page_name,
    'page_type': obj.page_type,
    'zone': obj.zone,
    'activity': obj.activity,
    'position': obj.position,
    'button_content': obj.button_content,
    'button_type': obj.button_type,
    'content_name': obj.content_name,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackPopinGalaxie = (event, page_name, page_type, zone, button_type) => {
  console.log("reset 2")
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'zone': zone,
    'button_type': button_type,
    _clear: true
  })

  console.log(window.dataLayer)

};

export const trackSiteExpetise = (event, page_name, page_type, expertise_site_name, expertise_site_url) => {
  console.log("reset")
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })


  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'expertise_site_name': expertise_site_name,
    'expertise_site_url': expertise_site_url,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackPlaquetteEvent = (obj) => {
  if (!obj.page_name) { return false; }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': obj.event,
    'page_name': obj.page_name,
    'activity': obj.activity,
    'content_name': obj.content_name,
    'page_type': obj.page_type,
    'zone': obj.zone || '',
    'origin_page': getCookie('prevPath'),
    'external_link_url': obj.external_link_url,
    'external_link_text': obj.external_link_text,
    _clear: true
  })

  console.log(window.dataLayer)
}


export const trackPageCTAEvents = (obj) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': obj.event,
    'page_name': obj.page_name,
    'page_type': obj.page_type,
    'origin_page': getCookie('prevPath'),
    'activity': obj.activity,
    'button_content': obj.button_content,
    'button_type': obj.button_type,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackCTAJobApply = (obj) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  console.log(getCookie('prevPath'));
  window.dataLayer.push({
    'event': obj.event,
    'page_name': obj.page_name,
    'page_type': obj.page_type,
    'origin_page': getCookie('prevPath'),
    'button_content': obj.button_content,
    'button_type': obj.button_type,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackRealisationEvents = (obj) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': obj.event,
    'page_name': obj.page_name,
    'activity': obj.activity,
    'page_type': obj.page_type,
    'origin_page': getCookie('prevPath'),
    'page_category': obj.page_category,
    'content_name': obj.content_name,
    'button_content': obj.button_content,
    'button_type': obj.button_type,
    _clear: true
  })

  console.log(window.dataLayer)
};


export const trackInnovationEvents = (obj) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': obj.event,
    'page_name': obj.page_name,
    'page_type': obj.page_type,
    'zone': obj.zone,
    'button_content': obj.button_content,
    'button_type': obj.button_type,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackBiographyEvent = (event, page_name, page_type, origin_page, content_name, biography_action, biography_photo_url) => {

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'origin_page': getCookie('prevPath'),
    'content_name': content_name,
    'biography_action': biography_action,
    'biography_photo_url': biography_photo_url,
    _clear: true
  })
  console.log(window.dataLayer)
};


export const trackCtaGeneral = (event, page_name, page_type, origin_page, button_content, button_type) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'origin_page': getCookie('prevPath'),
    'button_content': button_content,
    'button_type': button_type,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackDocumentEvent = (event, page_name, page_type, zone, origin_page, button_type, pdf_name) => {

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'zone': zone,
    'origin_page': getCookie('prevPath'),
    'button_type': button_type,
    'pdf_name': pdf_name,
    'content_name': 'clic_pdf_telecharge',
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackDocumentEvent2 = (event, page_name, page_type, origin_page, button_type, pdf_name) => {

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'origin_page': getCookie('prevPath'),
    'button_type': button_type,
    'pdf_name': pdf_name,
    'content_name': 'clic_pdf_telecharge',
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackCtaInnovation = (event, page_name, page_type, zone, button_content, button_type) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'zone': zone,
    'button_content': button_content,
    'button_type': button_type,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackCtaPeriodique = (event, page_name, page_type, selected_date, button_content) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'selected_date': selected_date,
    'button_content': button_content,
    _clear: true
  })
  console.log(window.dataLayer)
};


export const trackDate = (event, page_name, page_type, selected_date) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'selected_date': selected_date,
    _clear: true
  })
  console.log(window.dataLayer)
};


export const trackMediaFiltre = (event, page_type, page_category, button_content) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'page_category': page_category,
    'button_content': button_content,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackMedia = (event, page_type, page_category, social_media, content_name) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'page_category': page_category,
    'social_media': social_media,
    'content_name': content_name,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackCP = (event, page_type, page_category, content_name) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'page_category': page_category,
    'content_name': content_name,
    _clear: true
  })
  console.log(window.dataLayer)
};

export const trackActualite = (event, page_type, page_category, content_name, page_origin) => {

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })

  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'page_category': page_category,
    'content_name': content_name,
    'page_origin': getCookie('prevPath'),
    _clear: true
  })
  console.log(window.dataLayer)
};


export const trackPublicationsDocument = (event, page_type, origin_page, pdf_image_click, page_category, pdf_name) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'origin_page': getCookie('prevPath'),
    'pdf_image_click': pdf_image_click,
    'page_category': page_category,
    'pdf_name': pdf_name,
    _clear: true
  })

  console.log(window.dataLayer)
};

export const trackSearch = (event, page_type, page_category, origin_page, search_keyword) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'page_category': page_category,
    'origin_page': getCookie('prevPath'),
    'search_keyword': search_keyword,
    _clear: true
  })
  console.log(window.dataLayer)
};


export const trackEventDate = (event, page_type, selected_date, page_category) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'selected_date': selected_date,
    'page_category': page_category,
    _clear: true
  })
  console.log(window.dataLayer)
};


export const trackMediaExternalLink = (event, page_type, page_category, origin_page, external_link_url, external_link_text, social_media) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'page_category': '$page_category',
    'origin_page': getCookie('prevPath'),
    'external_link_url': external_link_url,
    'external_link_text': external_link_text,
    'social_media': social_media,
    _clear: true
  })
  console.log(window.dataLayer)
};



export const trackPublicationFiltre = (event, page_type, page_category, button_content) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': event,
    'page_type': page_type,
    'page_category': page_category,
    'button_content': button_content,
    _clear: true
  })

  console.log(window.dataLayer)
};




export const trackCarouselEvent = (event, page_name, page_type, position, button_content, content_name, button_type, zone) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'position': position,
    'button_content': button_content,
    'content_name': content_name,
    'button_type': button_type,
    'zone': zone,
    _clear: true
  })
  console.log(window.dataLayer)
}


export const trackSubmitForm = (event, page_name, page_type, button_content, form_type, button_type) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    this.reset();
  })
  window.dataLayer.push({
    'event': event,
    'page_name': page_name,
    'page_type': page_type,
    'button_content': button_content,
    'form_type': form_type,
    'button_type': button_type,
    _clear: true
  })
  console.log(window.dataLayer)
}





